import {createI18n} from 'vue-i18n'

const i18n = createI18n({
    locale: appLocale,
    messages: appTranslations
})

export default i18n;